import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
var i = {
	16: {
		Artwork: (e) => /* @__PURE__ */ r(t, {
			viewBox: "0 0 16 16",
			fill: "none",
			...e,
			children: [
				/* @__PURE__ */ n("path", {
					d: "M4.5 1H9.79297L13.5 4.70703V14C13.5 14.4229 13.3946 14.6483 13.2715 14.7715C13.1483 14.8946 12.9229 15 12.5 15H4.5C4.07707 15 3.85168 14.8946 3.72852 14.7715C3.60536 14.6483 3.5 14.4229 3.5 14V2C3.5 1.57707 3.60536 1.35168 3.72852 1.22852C3.85168 1.10536 4.07707 1 4.5 1Z",
					fill: "#FCFBF8",
					stroke: "#DEDBD4"
				}),
				/* @__PURE__ */ n("path", {
					d: "M10 0.5V3.7C10 4.23333 10.2667 4.5 10.8 4.5H14L10 0.5Z",
					fill: "#EDEAE3"
				}),
				/* @__PURE__ */ n("rect", {
					x: 1,
					y: 8,
					width: 12.5,
					height: 6,
					rx: 1,
					fill: "#983B02"
				}),
				/* @__PURE__ */ n("path", {
					d: "M2.53445 12.5V9.22726H3.82564C4.07386 9.22726 4.28533 9.27467 4.46005 9.36949C4.63477 9.46324 4.76793 9.59374 4.85955 9.761C4.95224 9.92719 4.99858 10.119 4.99858 10.3363C4.99858 10.5536 4.95171 10.7454 4.85796 10.9116C4.76421 11.0778 4.62837 11.2072 4.45046 11.2999C4.27362 11.3926 4.05948 11.4389 3.80806 11.4389H2.98509V10.8844H3.6962C3.82937 10.8844 3.9391 10.8615 4.02539 10.8157C4.11275 10.7688 4.17774 10.7044 4.22035 10.6223C4.26403 10.5392 4.28587 10.4439 4.28587 10.3363C4.28587 10.2276 4.26403 10.1328 4.22035 10.0518C4.17774 9.96981 4.11275 9.90642 4.02539 9.86167C3.93803 9.81587 3.82724 9.79296 3.693 9.79296H3.22639V12.5H2.53445Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M5.53802 12.5V9.22726H6.82921C7.07744 9.22726 7.28891 9.27467 7.46362 9.36949C7.63834 9.46324 7.77151 9.59374 7.86313 9.761C7.95581 9.92719 8.00215 10.119 8.00215 10.3363C8.00215 10.5536 7.95528 10.7454 7.86153 10.9116C7.76778 11.0778 7.63195 11.2072 7.45404 11.2999C7.27719 11.3926 7.06306 11.4389 6.81164 11.4389H5.98866V10.8844H6.69978C6.83294 10.8844 6.94267 10.8615 7.02897 10.8157C7.11632 10.7688 7.18131 10.7044 7.22392 10.6223C7.2676 10.5392 7.28944 10.4439 7.28944 10.3363C7.28944 10.2276 7.2676 10.1328 7.22392 10.0518C7.18131 9.96981 7.11632 9.90642 7.02897 9.86167C6.94161 9.81587 6.83081 9.79296 6.69658 9.79296H6.22996V12.5H5.53802Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M8.41695 9.79775V9.22726H11.1048V9.79775H10.1029V12.5H9.4189V9.79775H8.41695Z",
					fill: "white"
				})
			]
		}),
		width: 16,
		height: 16
	},
	24: {
		Artwork: (e) => /* @__PURE__ */ r(t, {
			viewBox: "0 0 24 24",
			fill: "none",
			...e,
			children: [
				/* @__PURE__ */ n("path", {
					d: "M6 1.5H14.793L19.5 6.20703V21C19.5 21.5896 19.353 21.94 19.1465 22.1465C18.94 22.353 18.5896 22.5 18 22.5H6C5.41041 22.5 5.06001 22.353 4.85352 22.1465C4.64702 21.94 4.5 21.5896 4.5 21V3C4.5 2.41041 4.64702 2.06001 4.85352 1.85352C5.06001 1.64702 5.41041 1.5 6 1.5Z",
					fill: "#FCFBF8",
					stroke: "#DEDBD4"
				}),
				/* @__PURE__ */ n("path", {
					d: "M15 1V5C15 5.66667 15.3333 6 16 6H20L15 1Z",
					fill: "#EDEAE3"
				}),
				/* @__PURE__ */ n("rect", {
					x: 1,
					y: 12,
					width: 17,
					height: 8,
					rx: 1.5,
					fill: "#983B02"
				}),
				/* @__PURE__ */ n("path", {
					d: "M3.37926 18.5V14.1364H5.10086C5.43182 14.1364 5.71378 14.1996 5.94674 14.326C6.17969 14.451 6.35725 14.625 6.47941 14.848C6.60299 15.0696 6.66478 15.3253 6.66478 15.615C6.66478 15.9048 6.60228 16.1605 6.47728 16.3821C6.35228 16.6037 6.17117 16.7763 5.93395 16.8998C5.69816 17.0234 5.41265 17.0852 5.07742 17.0852H3.98012V16.3459H4.92827C5.10583 16.3459 5.25213 16.3153 5.36719 16.2543C5.48367 16.1918 5.57032 16.1058 5.62713 15.9964C5.68537 15.8856 5.71449 15.7585 5.71449 15.615C5.71449 15.4702 5.68537 15.3437 5.62713 15.2358C5.57032 15.1264 5.48367 15.0419 5.36719 14.9822C5.25071 14.9212 5.10299 14.8906 4.92401 14.8906H4.30185V18.5H3.37926Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M7.38403 18.5V14.1364H9.10562C9.43659 14.1364 9.71855 14.1996 9.9515 14.326C10.1845 14.451 10.362 14.625 10.4842 14.848C10.6078 15.0696 10.6695 15.3253 10.6695 15.615C10.6695 15.9048 10.607 16.1605 10.482 16.3821C10.357 16.6037 10.1759 16.7763 9.93872 16.8998C9.70292 17.0234 9.41741 17.0852 9.08218 17.0852H7.98488V16.3459H8.93304C9.11059 16.3459 9.2569 16.3153 9.37196 16.2543C9.48843 16.1918 9.57508 16.1058 9.6319 15.9964C9.69014 15.8856 9.71926 15.7585 9.71926 15.615C9.71926 15.4702 9.69014 15.3437 9.6319 15.2358C9.57508 15.1264 9.48843 15.0419 9.37196 14.9822C9.25548 14.9212 9.10775 14.8906 8.92877 14.8906H8.30662V18.5H7.38403Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M11.2226 14.897V14.1364H14.8064V14.897H13.4705V18.5H12.5585V14.897H11.2226Z",
					fill: "white"
				})
			]
		}),
		width: 24,
		height: 24
	},
	40: {
		Artwork: (e) => /* @__PURE__ */ r(t, {
			viewBox: "0 0 40 40",
			fill: "none",
			...e,
			children: [
				/* @__PURE__ */ n("path", {
					d: "M10 2.5H24.793L32.5 10.207V35C32.5 35.9229 32.2696 36.5233 31.8965 36.8965C31.5233 37.2696 30.9229 37.5 30 37.5H10C9.07707 37.5 8.47668 37.2696 8.10352 36.8965C7.73036 36.5233 7.5 35.9229 7.5 35V5C7.5 4.07707 7.73036 3.47668 8.10352 3.10352C8.47668 2.73036 9.07707 2.5 10 2.5Z",
					fill: "#FCFBF8",
					stroke: "#DEDBD4"
				}),
				/* @__PURE__ */ n("path", {
					d: "M25 2V9C25 9.66667 25.3333 10 26 10H33L25 2Z",
					fill: "#EDEAE3"
				}),
				/* @__PURE__ */ n("rect", {
					x: 3,
					y: 21,
					width: 25,
					height: 13,
					rx: 2,
					fill: "#983B02"
				}),
				/* @__PURE__ */ n("path", {
					d: "M6.56889 31V24.4546H9.15128C9.64773 24.4546 10.0707 24.5494 10.4201 24.739C10.7695 24.9265 11.0359 25.1875 11.2191 25.522C11.4045 25.8544 11.4972 26.2379 11.4972 26.6726C11.4972 27.1073 11.4034 27.4908 11.2159 27.8232C11.0284 28.1556 10.7567 28.4144 10.4009 28.5998C10.0472 28.7852 9.61896 28.8779 9.11612 28.8779H7.47017V27.7688H8.8924C9.15874 27.7688 9.3782 27.723 9.55078 27.6314C9.7255 27.5377 9.85547 27.4087 9.9407 27.2447C10.0281 27.0785 10.0717 26.8878 10.0717 26.6726C10.0717 26.4553 10.0281 26.2656 9.9407 26.1037C9.85547 25.9396 9.7255 25.8129 9.55078 25.7234C9.37607 25.6318 9.15448 25.586 8.88601 25.586H7.95277V31H6.56889Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M12.576 31V24.4546H15.1584C15.6549 24.4546 16.0778 24.5494 16.4272 24.739C16.7767 24.9265 17.043 25.1875 17.2263 25.522C17.4116 25.8544 17.5043 26.2379 17.5043 26.6726C17.5043 27.1073 17.4106 27.4908 17.2231 27.8232C17.0356 28.1556 16.7639 28.4144 16.4081 28.5998C16.0544 28.7852 15.6261 28.8779 15.1233 28.8779H13.4773V27.7688H14.8996C15.1659 27.7688 15.3853 27.723 15.5579 27.6314C15.7326 27.5377 15.8626 27.4087 15.9478 27.2447C16.0352 27.0785 16.0789 26.8878 16.0789 26.6726C16.0789 26.4553 16.0352 26.2656 15.9478 26.1037C15.8626 25.9396 15.7326 25.8129 15.5579 25.7234C15.3832 25.6318 15.1616 25.586 14.8932 25.586H13.9599V31H12.576Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M18.3339 25.5955V24.4546H23.7096V25.5955H21.7057V31H20.3378V25.5955H18.3339Z",
					fill: "white"
				})
			]
		}),
		width: 40,
		height: 40
	}
}, a = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: i[t],
	...r
});
//#endregion
export { a as FilePptIcon };
